import * as React from 'react'
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import { withTranslation, WithTranslation } from 'react-i18next'

export interface BarData {
  [k: string]: number
}

interface BarDataColor {
  [k: string]: string
}

interface OwnProps {
  data: BarData[]
  colors: BarDataColor
}

type Props = OwnProps & WithTranslation

class BarsView extends React.PureComponent<Props> {
  constructor(props: Props) {
    super(props)

    this.tooltipContent = this.tooltipContent.bind(this)
  }

  public render() {
    return (
      <ResponsiveContainer width="100%" height={180}>
        <BarChart
          width={130}
          height={200}
          data={this.props.data}
          margin={{ left: 0, top: 0, bottom: 0, right: 0 }}
          barCategoryGap={0}
        >
          <YAxis label={undefined} hide={true} domain={[0, 100]} />
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          {Object.keys(this.props.data[0]).map((datum, index) => {
            return (
              <Bar
                key={'bar-' + index}
                dataKey={datum}
                stackId={datum.substr(0, 4)}
                fill={this.props.colors[datum]}
                isAnimationActive={false}
              />
            )
          })}
          <Tooltip content={this.tooltipContent} />
        </BarChart>
      </ResponsiveContainer>
    )
  }

  private tooltipContent({ active, payload }: { active: boolean; payload: any[]; label: any }) {
    if (active && payload[0]) {
      const data = payload[0].payload
      return (
        <div className="recharts-tooltip-wrapper recharts-tooltip-wrapper-right recharts-tooltip-wrapper-bottom">
          <div
            className="recharts-default-tooltip"
            style={{
              margin: 0,
              padding: 10,
              backgroundColor: 'rgb(255, 255, 255)',
              border: '1px solid rgb(204, 204, 204)',
              whiteSpace: 'nowrap',
            }}
          >
            <p className="recharts-tooltip-label time-label" style={{ margin: 0 }}>
              {
                // format(parse(a.label), 'D/M/YYYY')
              }
            </p>
            {Object.keys(data).map((l: string) => (
              <p key={l} className="recharts-tooltip-label" style={{ margin: 0, color: this.props.colors[l] }}>
                {' ' + this.props.t('plantAnalysis.legend.manAutoLocSec.' + l, { defaultValue: l })}:{' '}
                {Number.parseFloat(data[l]).toFixed(2)} %
              </p>
            ))}
          </div>
        </div>
      )
    }

    return null
  }
}

export default withTranslation()(BarsView)
